<template>
  <div
    :class="classes"
    class="base-section-heading"
  >
    <base-avatar
      v-if="icon"
      :icon="icon"
      :outlined="outlined"
      class="mb-4"
      color="primary"
      dark
    />

    <base-subheading
      v-if="title"
      :align="align"
      :title="title"
      :color="color"
      :size="size"
      :mobile-size="mobileSize"
      :class="isUppercase ? 'text-uppercase' : ''"
      space="1"
    />

    <base-subtitle
      v-if="subtitle"
      :title="subtitle"
      space="2"
      tag="h2"
    />

    <base-divider :color="color" />

    <base-body
      v-if="$slots.default || text"
      class="mx-auto"
      :class="isMobile ? 'px-1' : ''"
      max-width="750"
      :space="isMobile ? 4 : 10"
    >
      <slot v-if="$slots.default" />

      <template v-else>
        {{ text }}
      </template>
    </base-body>
  </div>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BaseSectionHeading',

    mixins: [Heading],

    props: {
      align: {
        type: String,
        default: 'center',
      },
      color: {
        type: String,
        default: 'primary',
      },
      icon: String,
      outlined: Boolean,
      space: {
        type: [Number, String],
        default: 12,
      },
      mobileSize: String,
      size: String,
      subtitle: String,
      text: String,
      title: String,
      isUppercase: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      classes () {
        return [
          `text-${this.align}`,
          `mb-${this.space}`,
        ]
      },
      isMobile() {
        return this.$vuetify.breakpoint.width <= 768
      },
    },
  }
</script>
